"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ajv_1 = __importDefault(require("ajv"));
const hiddenField = Symbol("SpecialTypeAnnotationFieldDoNotUse");
exports.TSJSON = {
    parse: (input) => JSON.parse(input),
    stringify: (input) => JSON.stringify(input)
};
class TsjsonParser {
    constructor(schema, ajvOptions = {}) {
        // call this to get the errors from the most recent validation call.
        this.getErrors = () => this.validator.errors;
        this.parse = (text, skipValidation = false) => {
            const data = JSON.parse(text);
            if (skipValidation) {
                return data;
            }
            if (this.validates(data)) {
                return data;
            }
            throw new Error(JSON.stringify(this.validator.errors));
        };
        this.schema = schema;
        const ajv = new ajv_1.default(ajvOptions);
        this.validator = ajv.compile(schema);
    }
    validates(data) {
        const valid = this.validator(data);
        if (!valid) {
            return false;
        }
        return true;
    }
}
exports.TsjsonParser = TsjsonParser;
